 import Image1 from '../../assets/mary.png';
 import Image2 from '../../assets/swati-majumdar-1.png';
 import Image3 from '../../assets/facv.jpg';
 import Image4 from '../../assets/aakash-chaudhary-1.png';

 export const Data = [
    {
        id: 1,
        image: Image1,
        title: 'mary greg',
        description: 'Greg had handle a lot of work in web development as my developer and i will like to say honest and time handler, therefore i give him all my true.'
    },
        {
        id: 2,
        image: Image2,
        title: 'swati majumdar',
        description: 'Always available to help, incredibly proficient, hits deadlines without fail, hard working and trustworthy. In my experience, no project is too much trouble, and with Grey you really get a rare entity – someone that can simplify what can be a very complex industry at times.   I can recommend his services without hesitation.'
    },
        {
        id: 3,
        image: Image3,
        title: 'favour john',
        description: 'Just thought I’d share something with you about my website. I have had so much positive feedback from friends and family on how great the site looks, and have also sold four toppers already this week direct from the website. Thanks for making it look so professional!.'
    },
        {
        id: 4,
        image: Image4,
        title: 'Aakash chaudhary',
        description: 'I would have no problems in recommending Grey to anyone in the future and I have already mentioned his name amongst my colleagues and business associates. I am now looking to embark on a new project which I have asked Grey to assist me with and I am looking forward to working with him in the coming months.'
    },
 ];